module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Scholarship_Creation_11-e8b0a1232c2990c91ef6a65f53d19465.jpg";